export default function HeroSection() {
  const stats = [
    { value: '每日更新 50+ 部', label: '热播剧集同步更新' },
    { value: '1080P 蓝光画质', label: '即点即看无需等待' },
    { value: '全平台兼容', label: '手机电脑平板随心看' },
  ];

  return (
    <section id="hero" className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20cinema%20living%20room%20with%20large%20TV%20screen%20displaying%20colorful%20abstract%20streaming%20interface%2C%20soft%20ambient%20lighting%2C%20comfortable%20sofa%2C%20modern%20interior%2C%20cinematic%20atmosphere%2C%20dark%20accents%20with%20warm%20golden%20light%20spills%2C%20high%20quality%20editorial%20photography&width=1800&height=900&seq=hero-bg-cinema-2026&orientation=landscape"
          alt="小草影院高清追剧体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left text content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag above H1 */}
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs md:text-sm font-medium mb-5 whitespace-nowrap">
              每日更新 · 高清流畅 · 不缓冲追剧
            </span>

            {/* H1 */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black text-white leading-tight mb-4">
              小草影院
              <span className="block md:inline text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-primary-300 mt-1 md:mt-0 md:ml-3">
                — 最新电视剧高清全集在线观看平台
              </span>
            </h1>

            {/* Slogan */}
            <p className="text-lg md:text-xl text-white/80 font-medium mb-6">
              热播剧集不缓冲，海量高清即点即看
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mb-8">
              小草影院致力于为追剧爱好者提供最新、最全的电视剧高清全集资源。平台每日同步各大卫视及网络平台热播剧集，覆盖国产剧、港台剧、日韩剧、欧美剧等多种类型，所有视频均为高清画质，无需缓冲即可流畅观影。无论您是想追最新热播剧，还是重温经典全集，小草影院都能满足您的完整追剧需求。当前平台持续扩充内容库，确保每日剧集及时更新，让您不错过任何精彩剧集。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-300 whitespace-nowrap">
                    {s.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/50 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                浏览热播榜单
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full text-sm backdrop-blur-sm border border-white/20 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          {/* Right visual */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none flex items-center justify-center">
            <div className="relative w-full aspect-[4/3] max-w-md lg:max-w-none rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20streaming%20platform%20interface%20design%2C%20modern%20dark%20theme%20UI%20with%20drama%20poster%20thumbnails%20grid%2C%20cinematic%20golden%20accents%2C%20sleek%20video%20player%20frame%2C%20entertainment%20app%20aesthetic%2C%20dark%20background%20with%20warm%20highlights%2C%20streaming%20service%20concept&width=1200&height=900&seq=hero-visual-dramas-2026&orientation=landscape"
                alt="小草影院高清剧集播放界面"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}